const sourceTypeCopy = { Api: 'API', Internal: 'Internal', Scheduled: 'Scheduled', AutoSweeps: 'Auto Sweeps' };
export default sourceTypeCopy;



// WEBPACK FOOTER //
// ./src/components/TransferPanel/sourceTypeCopy.js